import type { RemovableRef} from '@vueuse/core';
import { StorageSerializers, useLocalStorage } from '@vueuse/core';
import { defineStore } from 'pinia';

type LoggingToggles = {
    [category: string]: boolean;
};

type LocalStorageState = {
    _showDebug: RemovableRef<boolean>;
    _enableAnalytics: RemovableRef<boolean>;
    _loggingToggles: RemovableRef<LoggingToggles>;
};

export const useLocalStorageStore = defineStore('localStorage', {
    state: (): LocalStorageState => ({
        /** Show debug */
        _showDebug: useLocalStorage<boolean>('showDebug', false, { serializer: StorageSerializers.boolean }),
        /** Enable analytics */
        _enableAnalytics: useLocalStorage<boolean>('enableAnalytics', false, { serializer: StorageSerializers.boolean }),
        /** Console logging category toggles */
        _loggingToggles: useLocalStorage<LoggingToggles>('sysarb_logging_toggles', {}, { serializer: StorageSerializers.object }),
    }),
    getters: {
        showDebug: state => state._showDebug,
        enableAnalytics: state => state._enableAnalytics,
        loggingToggles: state => state._loggingToggles
    },
    actions: {
        setShowDebug(state: boolean): void {
            this._showDebug = state;
        },
        setEnableAnalytics(state: boolean): void {
            this._enableAnalytics = state;
        },
        setLoggingToggle(category: string, enabled: boolean): void {
            this._loggingToggles[category] = enabled;
        },
        clearLoggingToggles(): void {
            this._loggingToggles = {};
        }
    }
});
